import React, { useState,useEffect, useCallback, useContext } from "react";
import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import { DynamicContext } from "../../Context/DynamicContext";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    transformOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    anchorOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
), {
  shouldForwardProp: (prop) => prop !== "isDarkMode",
})(({ isDarkMode }) => ({        
  "& .MuiPaper-root": {
    borderRadius: 16,
    marginTop: "-1px",
    // marginLeft: "-6px",
    minWidth: "var(--menu-width)",
    color: "var(--header__color)",
    border: "1px solid var(--border__color)",
    padding: "10px",
    backgroundColor: "var(--body__background)",
    "& .MuiMenu-list": {
      padding: "8px 0",
      backgroundColor: "var(--body__background)",
      color: "var(--header__color)",
    },
    "& .MuiMenuItem-root": {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      padding: "10px",
      fontFamily: "Satoshi",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
      borderRadius: 10,
      "&:hover": {
        backgroundColor: isDarkMode ?  "#2D2D2D" :  "#e7e5ff",
        color: isDarkMode ? "#2D2D2D" : "#ffffff",
      },
      "& .MuiSvgIcon-root": {
        fontSize: 15,
      },
    },
  },
}));

const StyledDivider = styled(Divider)(() => ({
  backgroundColor: "var(--popup_Item_Hover)",
  marginTop: 6,
  marginBottom: 6,
}));

const DropdownMenu = ({ menuOpen, popupItems, onClose, anchorEl: anchorElProp, customClass }) => {
  const { isDarkMode } = useContext(DynamicContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const updateMenuWidth = useCallback(() => {
  if (anchorElProp) {
    const width = anchorElProp.getBoundingClientRect().width;
    document.documentElement.style.setProperty('--menu-width', `${width}px`);
  }
}, [anchorElProp]);

  useEffect(() => {
  if (menuOpen) {
    updateMenuWidth();
    window.addEventListener("resize", updateMenuWidth);
    return () => {
    window.removeEventListener("resize", updateMenuWidth);
      };
    }
  }, [menuOpen, updateMenuWidth]);

  useEffect(() => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' || mutation.type === 'childList') {
        updateMenuWidth();
      }
    });
  });
  if (anchorElProp) {
    observer.observe(anchorElProp, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }
  return () => observer.disconnect();
}, [updateMenuWidth, anchorElProp]);

 const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <StyledMenu
        isDarkMode={isDarkMode}
        anchorEl={anchorElProp}
        open={menuOpen && Boolean(anchorElProp)}
        onClose={handleClose}
        className={customClass}
        MenuListProps={{
          "aria-labelledby": "customized-button",
        }}
        anchorReference="anchorEl"
        keepMounted={false}
      >
        {popupItems.map((item, index) => [
          <MenuItem
            key={`menu-item-${index}`}
            onClick={() => {
              handleClose();
              item.eventHandler();
            }}
            disableRipple
          >
            <img
              src={item.icon}
              alt={item.name}
              style={{ width: 20, height: 20 }}
            />
            <span className="popup-item-text">{item.name}</span>
          </MenuItem>,
          item.divider && <StyledDivider key={`divider-${index}`} />,
        ])}
      </StyledMenu>
    </div>
  );
};

export default DropdownMenu;